<template>
  <div class="teachers-container">
    <el-card>
      <template #header>
        <span>Teacher Management</span>
      </template>
      <!-- Add Teacher Form -->
      <el-card style="margin-bottom: 20px;">
        <div style="font-weight: bold; margin-bottom: 10px;">Add Teacher</div>
        <image-upload v-model="form.teacher_image" style="margin-bottom: 10px;" />
        <el-input v-model="form.teacher_name" placeholder="Please enter teacher name" style="margin-bottom: 10px; width: 300px;" />
        <el-input v-model="form.teacher_description" type="textarea" :rows="2" placeholder="Please enter teacher introduction" style="margin-bottom: 10px; width: 400px;" />
        <el-button type="primary" @click="submitTeacher">Add Teacher</el-button>
      </el-card>
      <!-- Draggable Teacher List -->
      <draggable v-model="teacherList" handle=".drag-handle" @end="onDragEnd">
        <transition-group>
          <el-card v-for="(teacher, index) in teacherList" :key="teacher.id" style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center;">
              <span class="drag-handle" style="cursor: move; margin-right: 10px;">☰</span>
              <img :src="teacher.teacher_image" style="width: 50px; height: 50px; border-radius: 50%; margin-right: 10px;" />
              <div style="flex-grow: 1;">
                <div style="font-weight: bold;">{{ teacher.teacher_name }}</div>
                <div style="color: #888;">{{ teacher.teacher_description }}</div>
              </div>
              <el-button size="mini" @click="handleEditTeacher(teacher)" style="margin-right: 5px;">Edit</el-button>
              <el-button size="mini" type="danger" @click="handleDeleteTeacher(teacher)">Delete</el-button>
            </div>
          </el-card>
        </transition-group>
      </draggable>
      <!-- Edit Teacher Dialog -->
      <!-- Edit Teacher Dialog -->
      <el-dialog :title="'编辑老师'" :visible.sync="editDialog" width="500px">
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="头像">
            <image-upload v-model="editForm.teacher_image" />
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="editForm.teacher_name" />
          </el-form-item>
          <el-form-item label="介绍">
            <el-input type="textarea" v-model="editForm.teacher_description" :rows="2" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="editDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitEditTeacher">保 存</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload.vue'
import { getTeacherList, addTeacher, updateTeacher, deleteTeacher,updateTeacherOrder } from '@/api/teacher'
import draggable from 'vuedraggable'

export default {
  name: 'AdminTeachers',
  components: { ImageUpload, draggable },
  data() {
    return {
      form: {
        teacher_image: '',
        teacher_name: '',
        teacher_description: ''
      },
      teacherList: [],
      editDialog: false,
      editForm: {
        id: '',
        teacher_image: '',
        teacher_name: '',
        teacher_description: ''
      }
    }
  },
  created() {
    this.fetchTeacherList()
  },
  methods: {
    async fetchTeacherList() {
      try {
        const res = await getTeacherList()
        this.teacherList = Array.isArray(res) ? res : []
      } catch (e) {
        this.teacherList = []
      }
    },
    async submitTeacher() {
      if (!this.form.teacher_image || !this.form.teacher_name || !this.form.teacher_description) {
        this.$message.error('Please fill in all required information')
        return
      }
      try {
        await addTeacher(this.form)
        this.$message.success('Teacher added successfully')
        this.form = { teacher_image: '', teacher_name: '', teacher_description: '' }
        this.fetchTeacherList()
      } catch (e) {
        this.$message.error('Failed to add teacher')
      }
    },
    handleEditTeacher(row) {
      this.editForm = { ...row }
      this.editDialog = true
    },
    async submitEditTeacher() {
      if (!this.editForm.teacher_image || !this.editForm.teacher_name || !this.editForm.teacher_description) {
        this.$message.error('Please fill in all required information')
        return
      }
      try {
        await updateTeacher(this.editForm.id, this.editForm)
        this.$message.success('Saved successfully')
        this.editDialog = false
        this.fetchTeacherList()
      } catch (e) {
        this.$message.error('Failed to save')
      }
    },
    async handleDeleteTeacher(row) {
      this.$confirm('Are you sure you want to delete this teacher?', 'Warning', { type: 'warning' })
        .then(async () => {
          await deleteTeacher(row.id)
          this.$message.success('Deleted successfully')
          this.fetchTeacherList()
        })
        .catch(() => {})
    },
    async onDragEnd() {
      try {
        const teacher_ids = this.teacherList.map(t => t.id)
        // 调用后端 API 保存顺序
        await updateTeacherOrder({ teacher_ids })
        this.$message.success('Teacher order updated')
      } catch (e) {
        this.$message.error('Failed to update order')
      }
    }
  }
}
</script>

<style scoped>
.teachers-container {
  padding: 20px;
}
</style> 